<header>
  @if (!!previousUrl()) {
    <button (click)="onBack()" type="button">
      <svg viewBox="0 0 16 16" width="16" height="16">
        <use [attr.xlink:href]="SvgSpriteIcon.ArrowBack"></use>
      </svg>
      Back
    </button>
  }

  <h1>
    <lib-feature-description itemName="Detailed Report"/>
  </h1>
  <div class="tool-bar">
    @if (isMobile()) {
      <lib-select-button
        data-test="focus-period-selector"
        [options]="availablePeriods()"
        [model]="focusPeriod()"
        (modelChange)="updateFocusPeriod($event)"
      />
      <lib-sidebar-toggle
        [sidebar]="sidebar"
        [icon]="SvgSpriteIcon.Filter"
      />
    } @else {
      <lib-dropdown
        data-test="focus-period-selector"
        [options]="availablePeriods()"
        [model]="focusPeriod()"
        (modelChange)="updateFocusPeriod($event)"
        label="Period"
      />
      <lib-feature-tree-filters/>
    }
  </div>
</header>

<lib-sidebar
  #sidebar
  title="Filters"
  [(hidden)]="sidebarHidden"
>
  <lib-feature-tree-filters/>
</lib-sidebar>

<main>
  <lib-feature-tabular-summary title="Key Metrics"/>
  <lib-feature-trends/>
</main>

<aside>
  <lib-feature-dimension-breakdown/>
</aside>
